var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"evaluation-details-draw"},[_c('fm-title',{attrs:{"title-text":"个人总结填写"}}),(_vm.data)?_c('DetailsContent',{ref:"content",staticClass:"evaluation-details-content",attrs:{"data":_vm.data,"type":_vm.type},on:{"reload":_vm.loadData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }